import { Controller } from '@hotwired/stimulus'
import debounce from 'debounce';

export default class extends Controller {
  static targets = ['searchForm', 'searchField', 'searchClear']

  initialize() {
    this.submitSearch = debounce(this.submitSearch.bind(this), 150);
  }

  submitSearch() {
    this.searchFormTarget.requestSubmit()
    if (this.searchFieldTarget.value) {
      // both vocabularies until P5: Bootstrap surfaces use d-none, civic uses hidden
      this.searchClearTarget.classList.remove("d-none", "hidden")
    } else {
      this.searchClearTarget.classList.add("d-none", "hidden")
    }
  }

  clearSearch() {
    this.searchFieldTarget.value = "";
    this.searchFieldTarget.focus();
    this.submitSearch();
  }
}
